module.exports = __webpack_public_path__ + "static/media/login-illust.90a9124c.png";